<template>
  <div class="position-relative">
    <v-app class="p-4">
      <!--        <ads-selector></ads-selector>-->
      <div class="mt-10 pt-15 px-0 float-left">
        <extra-buttons></extra-buttons>
      </div>

      <v-tabs v-model="tab" color="deep-purple accent-4" class="mt-5" grow>
        <v-tab @change="getVal(item.value)" v-for="item in TabsName" :key="item.value">{{ item.name }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in myComponents" :key="item">
          <component v-if="activeComponent === item.value" :de-active="false" :is="item.name" :key="item.value"></component>
        </v-tab-item>
      </v-tabs-items>

    </v-app>
  </div>
</template>

<script>
import TitleRibbon from "../../uiBeautifier/titleRibbon";
import ExtraButtons from "../../uiBeautifier/extraButtons";
import singleMarket from "../singleAds/marketPlace/marketSendAds";
import multiMarket from "../singleAds/marketPlace/multiMarketplace";
export default {
  name: "marketPlace",
  components: {singleMarket, ExtraButtons, TitleRibbon,multiMarket},
  data() {
    return {
      myComponents: [{name:'singleMarket',value:'single'}, {name: 'multiMarket' ,value: 'multi'},],
      TabsName: [{name: 'ارسال تکی', value: 'single'}, {name: 'ارسال گروهی', value: 'multi'}],
      tab: '',
      activeComponent: 'single'
    }

  },
  methods: {
    getVal(val) {
      this.activeComponent = val
    }
  },
}
</script>

<style scoped>

</style>